// Returns August 1 of either the current or past year, depending on which month we're in:
export function startOfSchoolYear(date = new Date()) {
  const month = date.getMonth()
  const year = month >= 7 ? date.getFullYear() : date.getFullYear() - 1
  return new Date(year, 7, 1)
}
